import { SET_RENDER_SETTINGS } from '../actions/types';

export default function renderSettings(state = {}, action) {
	if (!action.error && action.payload) {
		const newProps = action.payload;
		switch (action.type) {
			case SET_RENDER_SETTINGS: {
				return {
					...state,
					...newProps
				};
			}
			// no default
		}
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/renderSettings.js